import NestError from "@/components/nesterror";

export default function Custom404() {
    return <NestError error={{ message:"Sorry, we couldn't locate the item you were looking for!"}} />
}